import { getColor } from './utils';

export type HealthScoreResult = {
  label: string;
  color: string;
  prClass: string;
};

const defaultHealthScore: HealthScoreResult = {
  label: '-',
  color: getColor('danger'),
  prClass: 'health-score-danger'
};

export default function healthScoreColorAndLabel(
  score: number | string | null | undefined
): HealthScoreResult {
  if (score == null || Number.isNaN(Number(score))) {
    return defaultHealthScore;
  }

  const numericScore = Number(score);

  if (numericScore >= 90) {
    return {
      label: 'A',
      color: getColor('success'),
      prClass: 'health-score-success'
    };
  }
  if (numericScore <= 89 && numericScore >= 79) {
    return { label: 'B', color: '#bb881d', prClass: 'health-score-yellow' };
  }
  if (numericScore <= 78 && numericScore >= 64) {
    return {
      label: 'C',
      color: getColor('warning'),
      prClass: 'health-score-warning'
    };
  }
  if (numericScore <= 63 && numericScore >= 50) {
    return {
      label: 'D',
      color: getColor('danger'),
      prClass: 'health-score-danger'
    };
  }
  if (numericScore <= 49 && numericScore >= 30) {
    return {
      label: 'E',
      color: getColor('danger'),
      prClass: 'health-score-danger'
    };
  }
  if (numericScore <= 29) {
    return {
      label: 'F',
      color: getColor('danger'),
      prClass: 'health-score-danger'
    };
  }

  return defaultHealthScore;
}
